<!--
 * @Description: 服务管理下的服务事项
 * @Author: sunhuihong
 * @Date: 2022-05-29 14:43:52
 * @LastEditTime: 2022-12-14 16:43:27
-->
<template>
   <div class="hsvc-matter-body">
    <el-row class="bk-search" style="margin: 25px 40px;" :gutter="0" type="flex" justify="space-between" >
      <el-col :span="8" style="text-align: left">
        <span class="search-title">机构名称：</span>
        <el-select size="small" style="width: 240px;"  filterable  v-model="filterParams.institutionId" clearable  
          placeholder="请输入/选择" 
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this))"
					@visible-change="(visible) => 
            commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)">
          <el-option v-for="item in institutionList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" style="text-align: right;">
        <el-button size="small" @click="handleQuery"  type="primary" icon="el-icon-search">搜 索</el-button>
        <el-button size="small" class="import-style" 
          @click="handleImportServiceItem(filterParams.institutionId)" plain >
          模板导入
        </el-button>
      </el-col>      
    </el-row>
    <div class="main-line"></div>
    <div class="back-card">
      <el-row type="flex" class="row-bg" :gutter="20">
        <el-col :span="8" v-for="(item,index) in hsvcMatterList" :key="index">
          <el-card class="box-card" shadow="never" :body-style="{ padding:'0px','background-color': '#FAFBFF',}">
            <div class="box-card-main">
              <div class="box-card-header">
                <div class="institution-name">{{item.institutionName}}</div>
              </div>
              <div class="box-card-content">
                <div v-if="item.matterDTOList && item.matterDTOList.length">
                  <div class="box-card-content-header" 
                    @click="handleAddGroup(item)">
                    <span style="margin-right: 6px; font-size: 18px;"><i class="el-icon-plus"></i></span>
                    <span style="font-size: 14px; line-height: 20px;">新建分组</span>
                  </div>
                  <el-tree class="tree-style" empty-text="" :data="item.matterDTOList" :props="defaultProps" node-key="id" 
                    ref="tree" :default-expanded-keys="item.defaultOpenId"  highlight-current >
                    <span class="custom-tree-node" slot-scope="{ node, data }" @mouseover="mouseover(data)" 
                      @mouseleave="mouseout(data)">
                      <span class="tree-label"> 
                        {{ node.label }}
                      </span>
                      <div  v-show="data.dropdownShow" style="flex: 1; text-align: right;">
                        <el-dropdown placement="bottom-end" trigger="hover" size="medium">
                          <img class="tree-more" src="@/assets/hsvcmng/icon-hsvcmng-more.png" alt="" >
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-if="data.parentId == 0" 
                              @click.native="handleAddTemplate(node, data, item.institutionId)" >
                              新增模板
                            </el-dropdown-item>
                            <el-dropdown-item 
                              @click.native="handleEditGroupOrTemplateName(node, data, item.institutionId)">
                              修改名称
                            </el-dropdown-item>
                            <el-dropdown-item v-if="data.parentId !== 0" 
                              @click.native="handleEdiContent(node, data, item.institutionId)" >
                              修改内容
                            </el-dropdown-item>
                            <el-dropdown-item  
                              @click.native="handleDeleteGroup(node, data, item.institutionId)">
                              {{data.parentId == 0 ? '删除分组' : '删除模板'}}
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </span>
                  </el-tree>
                </div>
                <div v-else class="div-no-data" >
                  <div @click="handleAddGroup(item)"
                    style="cursor: pointer;">
                    <span style="margin-right: 6px; font-size: 18px;"><i class="el-icon-plus"></i></span>
                    <span style="font-size: 14px; line-height: 20px;">
                      新建分组
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage" 
      :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize" 
      layout="total, prev, pager, next, sizes, jumper" :total="totalNumber" />
    </el-row>

    <!-- 服务事项导入组件 -->
    <matter-import :showMatterImport="showMatterImport" :institutionId="filterParams.institutionId"  
      @handle-close-import-dialog="handleCloseImportDialog"/> 

    <!-- 新增服务事项组对话框组件 -->
    <add-group-dialog :showAddGroupDialog="showAddGroupDialog" :institutionId="instId" :serviceItemId="serviceItemId"  
      :mode="groupMode" @handle-close-group-dialog="handleCloseGroupDialog"/>

    <!-- 新增服务事项模板对话框组件 -->
    <add-template-dialog :showAddTemplateDialog="showAddTemplateDialog"  :institutionId="instId" 
      :serviceItemId="serviceItemId" :parentId="parentId" :mode="templateMode" 
      @handle-close-template-dialog="handleCloseTemplateDialog"/>

    <!-- 删除服务事项组对话框组件 -->
    <delete-group-dialog :showDeleteGroupDialog="showDeleteGroupDialog" :currentData="currentData" 
      @handle-close-delete-dialog="handleCloseDeleteDialog"/>

    <!-- 编辑服务事项内容对话框组件 -->
    <edit-content-dialog :showEditContentDialog="showEditContentDialog" :serviceItemId="serviceItemId"  
    :institutionId="instId" @handle-close-edit-content-dialog="handleEditContentDialog"/>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import ServiceItemContainer from './components/hsvcmatter/ServiceItemContainer.vue'
import AddGroupDialog from './components/hsvcmatter/AddGroupDialog.vue'
import AddTemplateDialog from './components/hsvcmatter/AddTemplateDialog.vue'
import DeleteGroupDialog from './components/hsvcmatter/DeleteGroupDialog.vue'
import EditContentDialog from './components/hsvcmatter/EditContentDialog.vue'
import MatterImport from  './components/MatterImport.vue'

export default {
  name: 'HsvcMatter',
  components: {
    'service-item-container': ServiceItemContainer,
    'add-group-dialog': AddGroupDialog,
    'add-template-dialog': AddTemplateDialog,
    'delete-group-dialog': DeleteGroupDialog,
    'edit-content-dialog': EditContentDialog,
    'matter-import': MatterImport, 
  },

  data() {
    return {
      filterParams: {
        institutionId: '',
        page: 1,
        pageSize: 6,
      },
      institutionList: [],
      srcInstitutionList: [],
      showMatterImport: false,        //是否显示系统导入服务事项dialog
      showAddGroupDialog: false,      //是否显示新增组dialog
      showAddTemplateDialog: false,   //是否显示新增模板dialog
      showDeleteGroupDialog: false,   //是否显示删除组dialog
      showEditContentDialog: false,   //是否显示编辑内容dialog
      groupMode: '',
      templateMode: '',
      hsvcMatterList: [],
      defaultProps: {
        children: 'matterDTOList',//指定子树为节点对象的某个属性值
        label: 'name',//指定节点标签为节点对象的某个属性值
      }, 
      defaultOpenId: [],//默认展开id集合
      pageSizes: [6,12,18],
      totalNumber: 0,
      currentData: {},
      serviceItemId: '',
      parentId: '',
      instId: '',//机构id
    }
  },
  
  methods:{
    async initData() {     
      await this.getFilterDo();
      await this.listHsvcMatter();
    },
    
    //获取过滤条件数据
    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_MATTER_FILTER_DO).then(result => {
          if (result != null) {
            this.institutionList = result.data;
            this.srcInstitutionList = result.data;
            if (this.globalData.adminType == 2) {
              this.$set(this.filterParams, 'institutionId', this.institutionList[0].id);
            }
            resolve();
          }
        })
      })
    },

    //获取服务事项数据
    listHsvcMatter() {
      return new Promise((resolve) => {
        let header = this.encryptionUtil.signatureParams(this.filterParams,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_PAGE_MATTERS,
          param: this.filterParams,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.hsvcMatterList = result.data;
            this.getDefaultOpenId();
            this.totalNumber = result.totalNumber;
            resolve();
          }
        })
      })
    },
    
    //在原数据里面设置每一项默认展开值
    getDefaultOpenId() {
      this.hsvcMatterList.forEach((item, _index) => {
        item.defaultOpenId = item.matterDTOList.length ? [item.matterDTOList[0].id] : [];             
      });
    },

    // 移入
    mouseover(data) { 
      this.$set(data, 'dropdownShow', true)
    },

    // 移除
    mouseout(data) { 
      this.$set(data, 'dropdownShow', false)
    },

    //新增组
    handleAddGroup(item) {
      this.groupMode = 'add';
      this.instId = item.institutionId;
      this.showAddGroupDialog = true;
    },

    //新增模板
    handleAddTemplate(_node,data,instId) {
      this.templateMode = 'add';
      this.showAddTemplateDialog = true;
      this.serviceItemId = data.id;
      this.parentId = data.id;
      this.instId = instId;
    },

    //编辑组或者模板名称
    handleEditGroupOrTemplateName(_node,data,instId) {
       if (data.parentId == 0) {
        this.groupMode = 'edit';
        this.serviceItemId = data.id;
        this.instId = instId;
        this.showAddGroupDialog = true;
      } else {
        this.templateMode = 'edit';
        this.serviceItemId = data.id;
        this.instId = instId;
        this.showAddTemplateDialog = true;
      }
    },

    //编辑内容
    handleEdiContent(_node,data,instId) {
      this.instId = instId;
      this.serviceItemId = data.id;
      this.showEditContentDialog = true;
    },
    
    //删除组或者模板
    handleDeleteGroup(_node,data,_instId) {
      this.currentData = data;
      this.showDeleteGroupDialog = true;
    },

    //系统导入服务事项
    handleImportServiceItem(instId) {
      if (instId !== '') {
        this.showMatterImport = true;
      } else {
        this.$message.error( "请先选择机构");
      }
    },
    
    //关闭导入服务事项dialog
    handleCloseImportDialog(refresh) {
      this.showMatterImport = false;
      if (refresh) {
        this.listHsvcMatter()
      }
    },

    //关闭新增组dialog
    handleCloseGroupDialog(refresh) {
      this.showAddGroupDialog = false;
      if (refresh) {
        this.listHsvcMatter()
      }
    },
    
    //关闭新增/编辑模板对话框
    handleCloseTemplateDialog(refresh) {
      this.showAddTemplateDialog = false;
      if (refresh) {
        this.listHsvcMatter()
      }
    },

    //关闭删除组或者模板dialog
    handleCloseDeleteDialog(refresh) {
      this.showDeleteGroupDialog = false;
      if (refresh) {
        this.listHsvcMatter()
      }
    },

    //关闭编辑内容dialog
    handleEditContentDialog(refresh) {
      this.showEditContentDialog = false;
      if (refresh) {
        this.listHsvcMatter()
      }
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.listHsvcMatter();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.listHsvcMatter();
    },
    
    handleQuery() {
      this.filterParams.page = 1;
      this.listHsvcMatter();
    },
  },

  mounted() {
    this.$emit("breadcrumb", {text1: '服务管理', text2: '服务事项'});
    this.initData();
  }
}
</script>
<style>
.hsvc-matter-body .el-tree {
  background-color: #FAFBFF;
}

.hsvc-matter-body .el-tree-node__content {
  padding: 0 8px 0  18px !important;
  background-color: #FAFBFF;
}

.hsvc-matter-body .el-tree-node__expand-icon {
  padding: 0px 5px 0px  0px !important;
  font-size: 18px;
}
</style>

<style scoped>
.hsvc-matter-body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.search-title {
  color: #657180;
  font-size: 14px;
  display: inline-block;
  text-align: right;
}

.main-line {
  height: 10px;
  background-color: #f0f0f0;
}

.row-bg {
  flex-wrap: wrap;
}

.hsvc-matter-body .back-card {
  margin: 21px 40px;
  text-align: left;
}

.hsvc-matter-body .box-card {
  margin-bottom: 20px;
}

.hsvc-matter-body .box-card-main {
  height: 352px;
  background-color: #FAFBFF;
}

.hsvc-matter-body .box-card-header {
  background-color: white;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  flex-direction: row;
  padding: 10px 18px; 
  justify-content: space-between;
  align-items: center;
}

.hsvc-matter-body .institution-name {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis; /* 文本溢出时显示省略号来代表被修剪的文本 */
  display: -webkit-box; /* 必须结合的属性 ，将对象作为弹性伸缩盒子模型显示 */
  -webkit-box-orient: vertical; /* 必须结合的属性 ，设置或检索伸缩盒对象的子元素的排列方式 */
  -webkit-line-clamp: 2; /* 文本需要显示多少行 */
}

.box-card-content {
  padding: 16px 0 21px 0px;
}

.box-card-content-header {
  display: flex;
  align-items: center;
  color: #4282F6;
  cursor: pointer;
  padding: 0px 8px 0px 18px;
}

.div-no-data {
  height: 264px;
  text-align: center;
  background-color:#FAFBFF;
  color: #4282F6;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hsvc-matter-body .tree-style {
  height: 264px;
  margin-top: 10px;
  overflow-y: auto;
  overflow-x: hidden;
}

.hsvc-matter-body .custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}

.hsvc-matter-body .tree-more {
  width:18px;
  height:18px;
  vertical-align: middle;
}

.hsvc-matter-body .view-service-item-right {
  flex: 1;
  text-align: left;
}

.hsvc-matter-body .edit-button-style {
  width: 80px;
  height: 30px;
  line-height: 5px;
}
.hsvc-matter-body .submit-button-style {
  width: 80px;
  height: 30px;
  line-height: 5px;
}

.foot-pagination {
  text-align: right;
  right: 40px;
  border: solid 0px;
}

.import-style {
  background: #EDF5FF;
  border: 1px solid #B4D8FF;
  color: #3E7EF5;
}

.tree-label {
  width: 160px; 
  text-align: left; 
  color: #7689A6; 
  font-size: 14px; 
  overflow: hidden; 
  text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components/hsvcmng/HsvcMatter.vue